import { Outlet } from 'react-router-dom'
import { ShieldAlert } from 'lucide-react'
import { useMeState } from '../lib/me.js'
import { canManage } from '../lib/role.js'

// Client-side gate for the Manager area (defense-in-depth on top of the
// middleware page gate). Renders the nested routes only for Manager / Stock
// Manager / Admin; everyone else gets a clean notice instead of a broken shell.
export default function RequireManager() {
  const { me, status } = useMeState()
  if (status === 'loading' && !me) {
    return <div className="px-10 py-8 text-[14px] text-slate-400">กำลังโหลด…</div>
  }
  if (!canManage(me)) {
    return (
      <div className="px-10 py-16 max-w-[560px] mx-auto text-center">
        <div className="w-12 h-12 rounded-xl bg-amber-50 text-amber-500 flex items-center justify-center mx-auto mb-4">
          <ShieldAlert size={22} strokeWidth={1.75} />
        </div>
        <h1 className="text-[18px] font-semibold text-slate-900 mb-1.5">เฉพาะผู้จัดการ</h1>
        <p className="text-[14px] text-slate-500 leading-relaxed">
          หน้านี้เข้าถึงได้เฉพาะบัญชีที่มีสิทธิ์ Manager, GM, Stock Manager หรือ Admin เท่านั้น
        </p>
      </div>
    )
  }
  return <Outlet />
}
